const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    RECEIVE_LOCALE: true,
    RECEIVE_MESSAGES: true,
});
